export const COMPONENT_NAME_FEATURE = 'Feature';
export const INACTIVE = 0;
export const ARIA_LIVE_VISIBILITY_DELAY_MS = 300;
